import { motion } from "framer-motion";
import { Brain, FileCheck, Shield, RefreshCw, BarChart3, AlertTriangle } from "lucide-react";
import { steddyTransition } from "@/lib/animations";

const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const features = [
  {
    icon: Brain,
    title: "AI-Powered Underwriting",
    description:
      "Leverage advanced AI for fast, data-driven underwriting decisions. Access capital almost instantly with minimal friction.",
  },
  {
    icon: FileCheck,
    title: "One Click Contracts",
    description:
      "Streamline your funding process with DocuSign integration. Sign deals in moments and get funds flowing automatically.",
  },
  {
    icon: Shield,
    title: "Compliance Engine",
    description:
      "Built-in regulatory compliance for MCA, state-by-state. Automated disclosure generation and audit trails.",
  },
  {
    icon: RefreshCw,
    title: "Auto Logins",
    description:
      "No more chasing merchants for hours to get a login. Steddy.AI handles automatic logins — no manual intervention needed.",
  },
  {
    icon: AlertTriangle,
    title: "AI Servicing Alerts",
    description:
      "Chargebacks, bounces, and defaults flagged instantly. AI-powered servicing alerts notify you of critical issues that need immediate attention.",
  },
  {
    icon: BarChart3,
    title: "Portfolio Analytics",
    description:
      "Real-time dashboards showing default rates, collection efficiency, and portfolio health for data-driven decisions.",
  },
];

const FeaturesSection = () => (
  <section id="features" className="bg-secondary/30 py-32">
    <div className="container mx-auto px-6">
      <motion.div {...fadeInUp} transition={steddyTransition} className="mb-16 text-center">
        <span className="text-xs font-semibold uppercase tracking-wider text-primary">
          Our Services
        </span>
        <h2 className="mt-4 text-3xl font-bold text-foreground md:text-4xl">
          End-to-end. Fully autonomous.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          From submission to final collection, Steddy.AI handles every step of the MCA lifecycle.
        </p>
      </motion.div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, i) => (
          <motion.div
            key={feature.title}
            {...fadeInUp}
            transition={{ ...steddyTransition, delay: i * 0.08 }}
            className="card-surface-light card-hover-light group rounded-2xl bg-background p-6"
          >
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
              <feature.icon className="h-5 w-5 text-primary" />
            </div>
            <h3 className="mb-2 text-lg font-semibold text-foreground">{feature.title}</h3>
            <p className="text-sm leading-relaxed text-muted-foreground">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
